package com.anjuros.website.templates.template8.modules

import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Res
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent

enum class Template8WhatsOn(
    val title: ResKey,
    val description: List<ResKey>,
    val image: String,
    val animatedTranslateX: CSSSizeValue<CSSUnit.percent>,
    val animatedTranslateY: CSSSizeValue<CSSUnit.percent>
) {
    TEMPLATE8_WHATSON1(
        title = ResKey.TEMPLATE8_SERVICE1_TITLE,
        description = listOf(
            ResKey.TEMPLATE8_SERVICE1_DESC1,
            ResKey.TEMPLATE8_SERVICE1_DESC2,
            ResKey.TEMPLATE8_SERVICE1_TIME
        ),
        image = Template8Res.Image.template8_whatson1,
        animatedTranslateX = 30.percent,
        animatedTranslateY = 10.percent
    ),
    TEMPLATE8_WHATSON2(
        title = ResKey.TEMPLATE8_SERVICE2_TITLE,
        description = listOf(
            ResKey.TEMPLATE8_SERVICE2_DESC1,
            ResKey.TEMPLATE8_SERVICE2_DESC2,
            ResKey.TEMPLATE8_SERVICE2_TIME
        ),
        image = Template8Res.Image.template8_whatson2,
        animatedTranslateX = (-30).percent,
        animatedTranslateY = 10.percent
    ),
    TEMPLATE8_WHATSON3(
        title = ResKey.TEMPLATE8_SERVICE3_TITLE,
        description = listOf(
            ResKey.TEMPLATE8_SERVICE3_DESC1,
            ResKey.TEMPLATE8_SERVICE3_DESC2,
            ResKey.TEMPLATE8_SERVICE3_TIME
        ),
        image = Template8Res.Image.template8_whatson3,
        animatedTranslateX = 30.percent,
        animatedTranslateY = (-10).percent
    ),
    TEMPLATE8_WHATSON4(
        title = ResKey.TEMPLATE8_SERVICE4_TITLE,
        description = listOf(
            ResKey.TEMPLATE8_SERVICE4_DESC1,
            ResKey.TEMPLATE8_SERVICE4_DESC2,
            ResKey.TEMPLATE8_SERVICE4_TIME
        ),
        image = Template8Res.Image.template8_whatson4,
        animatedTranslateX = (-30).percent,
        animatedTranslateY = (-10).percent
    )
}